<template>
    <div>
        <ul class="list-group mb-3" v-if="lista && lista.length">
            <li class="list-group-item" v-for="(amostra, iax) in lista" :key="iax">
                <div class="form-row">
                    <div class="col col-12 col-md-8">
                        <div>
                            <a href="#" class="card-link" @click.prevent="editar(amostra)">
                                {{ amostra.st_codigo }}
                            </a>
                            <span v-if="amostra.st_titulo">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ amostra.st_titulo }}
                            </span>
                            <span v-if="amostra.material">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ amostra.material.st_amostra_material }}
                            </span>
                            <span v-if="amostra.st_destino">
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                {{ amostra.st_destino }}
                            </span>
                        </div>
                        <div>
                            <a href="#" @click.prevent="abrir_atendimento(amostra.exame.atendimento_procedimento.id_atendimento)" class="card-link">
                                #{{ amostra.exame.atendimento_procedimento.id_atendimento }}
                            </a>
                            <span class="small text-muted ml-3" v-if="amostra.exame.atendimento_procedimento.atendimento.marcacao.st_id_externo">
                                {{ amostra.exame.atendimento_procedimento.atendimento.marcacao.st_id_externo }}
                            </span>
                            <span class="small text-muted ml-3">
                                {{ $util.getFormatDate(amostra.exame.atendimento_procedimento.atendimento.dt_inicio) }} {{ amostra.exame.atendimento_procedimento.atendimento.dt_inicio.substr(11,5) }}
                            </span>
                        </div>
                        <div>{{ amostra.exame.atendimento_procedimento.atendimento.paciente.st_nome }}</div>
                    </div>
                    <div class="col col-12 col-md-4 text-right">
                        <div v-if="amostra.rastro">
                            <span class="badge" :class="'badge-' + ( amostra.rastro.status_rastro.st_color ? amostra.rastro.status_rastro.st_color : 'secondary' )">
                                {{ amostra.rastro.status_rastro.st_amostra_rastro_status }}
                            </span>
                            <span v-if="amostra.rastro.st_bag_codigo">
                                <span class="badge ml-2" :class="'badge-' + ( amostra.rastro.status_rastro.st_color ? amostra.rastro.status_rastro.st_color : 'secondary' )">
                                    <i class="fa-solid fa-box-open fa-fw mr-2" v-if="amostra.rastro.status_rastro.st_id_externo == 'M'"></i>
                                    <i class="fa-solid fa-box-archive fa-fw mr-2" v-else-if="amostra.rastro.status_rastro.st_id_externo == 'C'"></i>
                                    {{ amostra.rastro.st_bag_codigo }}
                                </span>
                            </span>
                            <div class="small text-muted">
                                <span v-if="amostra.rastro.usuario">
                                    {{ amostra.rastro.usuario.st_login }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                </span>
                                {{ $util.getFormatDate(amostra.rastro.created_at) }} {{ amostra.rastro.created_at.substr(11,5) }}                               
                            </div>
                        </div>
                        <div>
                            <span class="badge ml-1" 
                                :class="( exame.atendimento_procedimento.laudo && exame.atendimento_procedimento.laudo.status_laudo && exame.atendimento_procedimento.laudo.status_laudo.st_color ) ? 'badge-' + exame.atendimento_procedimento.laudo.status_laudo.st_color : 'badge-secondary'" 
                                v-for="(exame, iex) in amostra.exames" :key="iex">
                                {{ exame.atendimento_procedimento.procedimento.st_sigla ? exame.atendimento_procedimento.procedimento.st_sigla : '#' + exame.atendimento_procedimento.procedimento.id_procedimento }}
                            </span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['lista'],

    methods: { 
        editar (amostra) { 
            this.$emit('editar', amostra);
        }, 

        abrir_atendimento (item) { 
            this.$util.abrir_atendimento(this, item.id_atendimento);    
        },
    }
}
</script>
